/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_SummaryInputs */

const en_resume_editor_summary = /** @type {(inputs: Resume_Editor_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary`)
};

const de_resume_editor_summary = /** @type {(inputs: Resume_Editor_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassung`)
};

const fr_resume_editor_summary = /** @type {(inputs: Resume_Editor_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const es_resume_editor_summary = /** @type {(inputs: Resume_Editor_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

const it_resume_editor_summary = /** @type {(inputs: Resume_Editor_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo`)
};

const nl_resume_editor_summary = /** @type {(inputs: Resume_Editor_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samenvatting`)
};

const pl_resume_editor_summary = /** @type {(inputs: Resume_Editor_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podsumowanie`)
};

const fi_resume_editor_summary = /** @type {(inputs: Resume_Editor_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteenveto`)
};

const da_resume_editor_summary = /** @type {(inputs: Resume_Editor_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumé`)
};

const sv_resume_editor_summary = /** @type {(inputs: Resume_Editor_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammanfattning`)
};

/**
* | output |
* | --- |
* | "Summary" |
*
* @param {Resume_Editor_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_summary = /** @type {((inputs?: Resume_Editor_SummaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_SummaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_summary(inputs)
	if (locale === "fr") return fr_resume_editor_summary(inputs)
	if (locale === "es") return es_resume_editor_summary(inputs)
	if (locale === "it") return it_resume_editor_summary(inputs)
	if (locale === "nl") return nl_resume_editor_summary(inputs)
	if (locale === "pl") return pl_resume_editor_summary(inputs)
	if (locale === "fi") return fi_resume_editor_summary(inputs)
	if (locale === "da") return da_resume_editor_summary(inputs)
	if (locale === "sv") return sv_resume_editor_summary(inputs)
	return en_resume_editor_summary(inputs)
});